// Port of api/fuel/app/classes/insights/game/related.php
import Segment from 'offline/insights/segment'
import Util from 'offline/util'
import Constants from 'offline/constants'

export default Segment.extend({
    name: 'related',
    priority: 2,
    enabled: false,
    requires: ['init'],
    insight: false,
    types: [Constants.TYPE_USER],
    run: function(type, owner, userIndex, detail, filter, vars) {

        var user_id = owner.get_id()
        var game_id = parseInt(vars.id, 10)

        var expansions = []
        var designerGames = []
        var alsoPlayed = []

        // Expansions: games where this game is the parent
        var expansionIds = Util.queryFast(
            'SELECT gr.game_relation_child AS child_id FROM game_relation gr WHERE gr.game_relation_parent = ' + game_id
        )

        if (expansionIds.length) {
            var childIds = Util.pluck(expansionIds, 'child_id')

            var owned = Util.queryFast(
                'SELECT c.game_id AS g FROM collection c ' +
                'WHERE c.user_id = ' + user_id + ' AND c.game_id IN(' + Util.in(childIds) + ') AND c.collection_own = 1'
            )

            var ownedIds = Util.pluck(owned, 'g')

            for (var ei = 0; ei < childIds.length; ei++) {
                var childId = parseInt(childIds[ei], 10)
                expansions.push({
                    id: childId,
                    owned: ownedIds.indexOf(childId) !== -1 && ownedIds.indexOf(String(childId)) !== -1 ? false : ownedIds.indexOf(childId) !== -1 || ownedIds.indexOf(String(childId)) !== -1
                })
                this._references.games.push(childId)
            }
        }

        // Same-designer games in user's collection
        var designers = Util.queryFast(
            'SELECT gd.designer_id FROM game_designer gd WHERE gd.game_id = ' + game_id
        )

        if (designers.length) {
            var designerIds = Util.pluck(designers, 'designer_id')

            var designerGamesRaw = Util.queryFast(
                'SELECT DISTINCT gd.game_id AS g FROM game_designer gd, collection c ' +
                'WHERE gd.designer_id IN(' + Util.in(designerIds) + ') AND gd.game_id != ' + game_id +
                ' AND gd.game_id = c.game_id AND c.user_id = ' + user_id + ' AND c.collection_own = 1'
            )

            for (var dg = 0; dg < designerGamesRaw.length; dg++) {
                var dgid = parseInt(designerGamesRaw[dg].g, 10)
                designerGames.push(dgid)
                this._references.games.push(dgid)
            }
        }

        // Also played: other games played by users who also played this game
        // No Booster in offline mode
        var sampleUsers = Util.queryFast(
            'SELECT user_id FROM play WHERE game_id = ' + game_id +
            ' GROUP BY user_id ORDER BY SUM(play_count) DESC LIMIT 50'
        )

        var sampleUserIds = Util.pluck(sampleUsers, 'user_id')
        var alsoPlayedRaw = []

        if (sampleUserIds.length) {
            alsoPlayedRaw = Util.queryFast(
                'SELECT p.game_id AS g, COUNT(DISTINCT p.user_id) AS c ' +
                'FROM play p WHERE p.user_id IN(' + Util.in(sampleUserIds) + ') AND p.game_id != ' + game_id +
                ' GROUP BY p.game_id ORDER BY c DESC LIMIT 10'
            )
        }

        for (var ap = 0; ap < alsoPlayedRaw.length; ap++) {
            var apgid = parseInt(alsoPlayedRaw[ap].g, 10)
            alsoPlayed.push({
                id: apgid,
                count: parseInt(alsoPlayedRaw[ap].c, 10)
            })
            this._references.games.push(apgid)
        }

        return {
            related: {
                expansions: expansions,
                designerGames: designerGames,
                alsoPlayed: alsoPlayed
            }
        }

    }
})
